// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__1SmQ0","hidden":"Video_hidden__kpkCf","exitBtn":"Video_exitBtn__2dDYw"};